export default __webpack_public_path__ + "static/media/gitlab.1a76ae85.png";